import { gql } from '__generated__';

export default gql(`
  mutation ToggleScanner($input: ToggleScannerInput!) {
    toggleScanner(input: $input) {
      id
      enabled
    }
  }
`);
